// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2IPCw","notes":"Notes_notes__1xRI6","note":"Notes_note__29kIO","markdown":"Notes_markdown__2Szo_"};